import { useEffect, useState } from "react";

// Returns true only after `flag` has been continuously true for `delayMs`, and resets to
// false immediately as soon as `flag` goes false. Used to avoid flashing a loader/shimmer
// for operations that resolve quickly (e.g. a stage-check API call that comes back fast).
const useDelayedFlag = (flag: boolean, delayMs: number): boolean => {
  const [delayedFlag, setDelayedFlag] = useState(false);

  useEffect(() => {
    if (!flag) {
      setDelayedFlag(false);
      return;
    }
    const timer = setTimeout(() => setDelayedFlag(true), delayMs);
    return () => clearTimeout(timer);
  }, [flag, delayMs]);

  return delayedFlag;
};

export default useDelayedFlag;
